module.exports = __webpack_public_path__ + "media/images/cip-b02e38e1a5cd2a4c6912579037b5af25.jpg";